import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/EditBlog.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';


const EditNewCourse =()=>{
      
 
        const initialFormData = {
            title:'',
            summary: '',
            body: '',
            field_taxo_courses: '_none',
            field_meta_title:'',
            field_meta_keywords:'',
            field_meta_description:'',
            field_apply_form_desc:'',
            field_application_key_name:'',
            field_weight:'',
            field_image:'',
            field_header_image:'',
            field_course_logo:'',
            field_delete_image:0,
            field_delete_course_logo:0,
            field_url_restriction:[],
            field_file_attachments:[],
            removed_fids:[],
            field_next_start_day:'',
            field_next_start_month:'',
            placements: [{ placement_page: '', placement_sort_order: '1' }],
			      deleted_placements: [],					   
            url_alias: '',
            nid:''
        };
        const [formData,setFormData] =useState(initialFormData);
        const [isLoading, setIsLoading] = useState(true);
        const [toggle, setToggle] = useState(2);
        const [errors, setErrors] = useState({});
        const [tempImage, setTempImage] = useState(null);
        const [tempImageLogo, setTempImageLogo] = useState(null);
        const [imageUploadError, setImageUploadError] = useState('');
        const [imageUploadErrorLogo, setImageUploadErrorLogo] = useState('');
        const [selectedImage, setSelectedImage] = useState(null);
        const [uploadedImage, setUploadedImage] = useState(null);
        const [selectedLogoImage, setSelectedLogoImage] = useState(null);
        const [uploadedLogoImage, setUploadedLogoImage] = useState(null);
        const [showSummary, setShowSummary] = useState(false);
        const [useRichEditor, setUseRichEditor] = useState(true);
        const [savedData, setSavedData] = useState(initialFormData);
        const [PreviewFields, setPreviewFields] = useState(false);
        const [viewChanges, setViewChanges] = useState(false);
        const [originalData, setOriginalData] = useState(null);
        const [formDataSnapshot, setFormDataSnapshot] = useState(null);
        const [previewData, setPreviewData] = useState(null);
        const [detailedview, setDetailedView] = useState({});
        const [disabled, setDisabled] = useState(false);
        const [buttontext, setButtonText] = useState("Save");
         const [slug, setSlug] = useState("Save");
        const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
        const [imageState, setImageState] = useState({
            image: {
              temp: null,
              selected: null,
              error: ''
            },
            logo: {
              temp: null,
              selected: null,
              error: ''
            }
          });
        const [selectedFiles, setSelectedFiles] = useState([]);
        const [uploadedFiles, setUploadedFiles] = useState([]);
        const [backenduploadedFiles, setBackendUploadedFiles] = useState([]);
        const [fileInputKey, setFileInputKey] = useState(0);
        const [errorMessage, setErrorMessage] = useState('');
        const [backenderrorMessage, setBackendErrorMessage] = useState('');
        
    
const backendFiles = Array.isArray(backenduploadedFiles)
  ? backenduploadedFiles
  : [];
     const [courses, setCourses] = useState([]);
   const [pages, setPages] = useState([]);

      const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" }
    ];
    const days = Array.from({ length: 31 }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return { value: day, label: day };
    });
     const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const domainName = window.location.hostname;

            const location  = useLocation();
            const drupal_uid = localStorage.getItem('drupal_uid');
           
            const {tab} = useParams();
            const loggedin_uid = localStorage.getItem('uid');
            const navigate = useNavigate();
            const app_url = configData.APP_URL;
            const domain_url = configData.DOMAIN_URL;
           
            const path = location.pathname.replace(/^\/+/, "");

            const [page, setPage] = useState(null);
  async function getplacementlist() {
    
         try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }
        
  }

       
            function updateToggle(id){
                setToggle(id);
        
                if(id == 1) { 
                  window.location.href = "/" + page.url_slug;
                }
                if(id == 2) { 
                  navigate("/"+page.url_source+"/edit");
                }
                
            }

    // const getPageTitle = () => {
    //   const title = originalData?.title || "";

    //   if (toggle === 1) {
    //     return title ? title : "Course";
    //   } else if (toggle === 2) {
    //     return title ? `Edit Course ${title}` : "Edit Course";
    //   }

    //   return "Edit Course"; 
    // };

    const getPageHeading = () => {
      const title = originalData?.title || "";

      if (toggle === 2) {
        return (
          <>
             Edit Course {title}
          </>
        );
      }

      return null;
    };

    useEffect(() => {
      Promise.all([
        getuserloggedinroles(), 
        getPageData(),
        getplacementlist(),
        getcourselist()
      ]).then(() => {
     
        setIsLoading(false);
       
      })
        
    } ,[]);
async function getPageData() {
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'coursepages/geteditpagedata?path='+path,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
              setPage(responsedata.data);
              setFormData({
                    ...responsedata.data,
                    placements: (responsedata.data.placements || []).map(item => ({
                        ...item,
                        isExisting: true,
                    })),
              });
              setOriginalData({
                ...responsedata.data,
                placements: responsedata.data.placements || [],
              });
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       
    }   
    async function getuserloggedinroles() {
   
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); 
          }
       
  }      
    
   async function getcourselist() {
    
         try {
            const response = await fetch(
                app_url+'report/getajaxcourselist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourses(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
      
      const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };
    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };

  const urlRestriction = [
    {value: configData.RSMWW_DOMAIN, label: "SportsManagementWorldwide.com"},
    {value: configData.RSMWW_AGENCY_DOMAIN, label: "SMWWAgency.com"},
    {value: configData.RSMWW_SCOUT_DOMAIN, label: "SMWWScout.com"}
  ]

  const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { placement_page: '', placement_sort_order: '1',isExisting: false, }],
        }));
    };

   // const handleDeletePlacement = (index) => {
    //    const updated = formData.placements.filter((_, i) => i !== index);
     //   setFormData((prev) => ({ ...prev, placements: updated }));						   
			//};
	
      const handleDeletePlacement = (index) => {
        setFormData((prev) => {
            const itemToDelete = prev.placements[index];

            let updatedDeleted = [...(prev.deleted_placements || [])];

            // Only store backend placements
            if (itemToDelete.isExisting && itemToDelete.placement_page) {
                updatedDeleted.push(itemToDelete.placement_page);
            }

            return {
                ...prev,
                placements: prev.placements.filter((_, i) => i !== index),
                deleted_placements: updatedDeleted,
            };
        });
    };									   
													
	//  const handlePlacementChange = (index, field, value) => {
						   
    //    const updated = [...formData.placements];
      //  updated[index][field] = value;
       // setFormData((prev) => ({ ...prev, placements: updated }));
	   
    //};
	const handlePlacementChange = (index, field, value) => {
    setFormData((prev) => {
        const updated = [...prev.placements];
        updated[index] = { ...updated[index], [field]: value };
        return { ...prev, placements: updated };
    });
    };
	
const handlePreviewClick = () => {
  setViewChanges(false);
  const {
    title,
    summary,
    body,
    field_taxo_courses,
    field_apply_form_desc,
    field_application_key_name,
    field_weight,
    field_image,
    field_meta_title,
    field_meta_keywords,
    field_meta_description, 
    field_course_logo,
    field_next_start_day,
    field_next_start_month,
    field_url_restriction,
  } = formData;


  const newErrors = {};
  if (!title?.trim()) {
    newErrors.title = "Title field is required.";
  }
    if (!field_weight?.trim()) {
            newErrors.field_weight = "Weight(lbs) field is required.";
            window.scrollTo(0, 0);
        }
 

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    setPreviewFields(false);
    return;
  }
  const bodyHtml = body || '';
  const hasSummary = summary && summary.trim() !== '';
  let trimmedHtml = '';

  if (hasSummary) {
  trimmedHtml = summary;
} else if (bodyHtml.includes('<!--break-->')) {
  trimmedHtml = bodyHtml.split('<!--break-->')[0];
} else {
  const tmp = document.createElement('div');
  tmp.innerHTML = bodyHtml;
  const plainText = (tmp.textContent || tmp.innerText || "").trim();

 trimmedHtml = '';
}

 

  setPreviewData({
    title,
    summary: hasSummary ? summary : '',
    trimmed: trimmedHtml,
    body: bodyHtml,
    field_taxo_courses,
    field_apply_form_desc,
    field_application_key_name,
    field_weight,
    field_meta_title,
    field_meta_keywords,
    field_meta_description,
    field_image,
    field_course_logo,
    field_next_start_day,
    field_next_start_month,
    field_url_restriction: Array.isArray(field_url_restriction) &&
    field_url_restriction.length === 0
    ? ''
    : field_url_restriction,
  });
  window.scrollTo(0, 0);
  setErrors({});
  setPreviewFields(true);  
};
const handleViewChangesClick = () => {
  setPreviewFields(false);

  const newErrors = {};

  if (!formData.title?.trim()) {
    newErrors.title = "Title field is required.";
  }

  if (!formData.field_weight?.trim()) {
    newErrors.field_weight = "Weight(lbs) field is required.";
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    setViewChanges(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return;
  }

  setViewChanges(true);

  setFormDataSnapshot({
    ...formData,
  });

  setOriginalData(prev => ({
    ...prev,
  }));

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const normalizeArray = (arr = []) =>
  Array.isArray(arr) ? arr.join(', ') : '';

    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;


        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };
      

    const getFileIcon = (fileName) => {
          if (!fileName || typeof fileName !== 'string') {
      return '/images/image-x-generic.png';
    }
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const maxSize = 128 * 1024 * 1024;

 const getFileName = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    return value.split("/").pop(); // extract filename from URL
  }
  if (value.name) return value.name; // File object or wrapper with .name
  if (value.file && value.file.name) return value.file.name; // wrapper {file, preview, name}
  return "";
};
const getImageSrc = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (value.url) return value.url;

  if (value.preview) return value.preview;

  if (value.file instanceof File)
    return URL.createObjectURL(value.file);

  if (value instanceof File)
    return URL.createObjectURL(value);
  return "";
};

const getLabels = (values) => {
  if (!values || !Array.isArray(values)) return [];
  return values.map(val => {
    const option = urlRestriction.find(opt => opt.value === val);
    return option ? option.label : val; // Fallback to value if label not found
  });
};
const MAX_FILE_SIZE = 2 * 1024 * 1024;

const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files);

    const allowedExtensions = [
        'jpg',
        'jpeg',
        'gif',
        'png',
        'txt',
        'doc',
        'xls',
        'pdf',
        'ppt',
        'pps',
        'odt',
        'ods',
        'odp'
    ];

    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
        const extension = file.name.split('.').pop().toLowerCase();

        const validType = allowedExtensions.includes(extension);
        const validSize = file.size <= MAX_FILE_SIZE;

        if (validType && validSize) {
            validFiles.push(file);
        } else {
            invalidFiles.push(file);
        }
    });

    if (invalidFiles.length > 0) {
        setErrorMessage(
            <>
                The selected file(s) <em>{invalidFiles.map(f => f.name).join(', ')}</em> cannot be uploaded.
                <br />
                Files must be less than <em>2 MB</em>.
                <br />
                Only files with the following extensions are allowed:
                <em> jpg jpeg gif png txt doc xls pdf ppt pps odt ods odp</em>.
            </>
        );

        setFileInputKey(prev => prev + 1);
    } else {
        setErrorMessage('');
    }

    setSelectedFiles(prev => [...prev, ...validFiles]);
};


    const handleUpload = () => {
        // Validate selected files
        const newFiles = selectedFiles.filter(file => {
         
            const isValidSize = file.size <= MAX_FILE_SIZE;
            return isValidSize;
        });

        setUploadedFiles(prev => [...prev, ...newFiles]);
        setErrorMessage('');
        setSelectedFiles([]);
        setFileInputKey(prev => prev + 1);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };
    const removeBackendFile = (index,removed_fid) => {
        setBackendUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    };
const handleTempImageChange = (e, type) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const maxSize = 128 * 1024 * 1024;

  

  // ---------- File type & size validation ----------
  if (!validTypes.includes(file.type)) {
    const errorHTML = `
      The selected file <em>${file.name}</em> cannot be uploaded.<br/>
      Only files with the following extensions are allowed:
      <em>png, gif, jpg, jpeg</em>.
    `;

    if (type === 'image') {
      setImageUploadError(errorHTML);
      setTempImage(null);
    } else {
      setImageUploadErrorLogo(errorHTML);
      setTempImageLogo(null);
    }

    e.target.value = '';
    return;
  }

  if (file.size > maxSize) {
    const errorHTML = `
      The selected file <em>${file.name}</em> cannot be uploaded.<br/>
      File must be less than <em>128 MB</em>.
    `;

    if (type === 'image') {
      setImageUploadError(errorHTML);
      setTempImage(null);
    } else {
      setImageUploadErrorLogo(errorHTML);
      setTempImageLogo(null);
    }

    e.target.value = '';
    return;
  }

  // ---------- Image dimension validation ----------
  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = () => {
    const width = img.width;
    const height = img.height;
    let errorHTML = '';



    URL.revokeObjectURL(objectUrl);

    // ---------- Dimension error ----------
    if (errorHTML) {
      if (type === 'preview') {
        setImageUploadError(errorHTML);
        setTempImage(null);
      } else {
        setImageUploadErrorLogo(errorHTML);
        setTempImageLogo(null);
      }

      e.target.value = '';
      return;
    }

    // ---------- SUCCESS ----------
    if (type === 'image') {
      setImageUploadError('');
      setTempImage({ file });
    } else {
      setImageUploadErrorLogo('');
      setTempImageLogo({ file });
    }
  };

  img.onerror = () => {
    URL.revokeObjectURL(objectUrl);

    const errorHTML = `
      The selected file <em>${file.name}</em> cannot be uploaded.<br/>
      Invalid image file.
    `;

    if (type === 'image') {
      setImageUploadError(errorHTML);
      setTempImage(null);
    } else {
      setImageUploadErrorLogo(errorHTML);
      setTempImageLogo(null);
    }

    e.target.value = '';
  };

  img.src = objectUrl;
};

const handleImageUploadClick = (type) => {
  const alltempImage = type === 'image' ? tempImage : tempImageLogo;

  if (alltempImage?.file) {
    const objectUrl = URL.createObjectURL(alltempImage.file);

    if (type === 'image') {
      setSelectedImage({
        file: alltempImage.file,
        preview: objectUrl
      });

      setFormData(prev => ({
        ...prev,
        field_image: alltempImage.file,
        field_delete_image: 0
      }));

      setImageUploadError('');
    } else {
      setSelectedLogoImage({
        file: alltempImage.file,
        preview: objectUrl
      });

      setFormData(prev => ({
        ...prev,
        field_course_logo: alltempImage.file,
        field_delete_course_logo: 0
      }));

      setImageUploadErrorLogo('');
    }
  }
};

 const handleRemoveSavedImage = (type) => {
  if (type === 'image') {
    setFormData(prev => ({
      ...prev,
      field_image: '',
      field_delete_image: 1
    }));
    setSelectedImage(null);
    setTempImage(null);
    setImageUploadError('');
  } else {
    setFormData(prev => ({
      ...prev,
      field_course_logo: '',
      field_delete_course_logo: 1
    }));
    setSelectedLogoImage(null);
    setTempImageLogo(null);
    setImageUploadErrorLogo('');
  }
};

const handleRemoveSelectedImage = (type) => {
  if (type === 'image') {
    setSelectedImage(null);
    setTempImage(null);
    setImageUploadError('');
    setFormData(prev => ({
      ...prev,
      field_image: '',
      field_delete_image: 0
    }));
  } else {
    setSelectedLogoImage(null);
    setTempImageLogo(null);
    setImageUploadErrorLogo('');
    setFormData(prev => ({
      ...prev,
      field_course_logo: '',
      field_delete_course_logo: 0
    }));
  }
};


 const formatFileSize = (size) => {
    if (size < 1024) return size + " Bytes";
    else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
    else return (size / (1024 * 1024)).toFixed(2) + " MB";
  };
const imageValue =
  selectedImage
    ? selectedImage.file
    : formData.field_image?.name;

let imageFileName = '';

if (imageValue instanceof File) {
  imageFileName = imageValue.name;
} else if (typeof imageValue === 'string') {
  imageFileName = imageValue.split('/').pop();
}
const logoImageValue =
  selectedLogoImage
    ? selectedLogoImage.file
    : formData.field_course_logo?.name;

let logoFileName = '';

if (logoImageValue instanceof File) {
  logoFileName = logoImageValue.name;
} else if (typeof logoImageValue === 'string') {
  logoFileName = logoImageValue.split('/').pop();
}

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    if (type === 'checkbox') {
      setFormData((prev) => {
        const current = Array.isArray(prev[name]) ? prev[name] : [];

        return {
          ...prev,
          [name]: checked
            ? [...current, value]
            : current.filter((v) => v !== value),
        };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
    
        const validateForm = () => {
            const newErrors = {};
            if (!formData.title.trim()) {
                newErrors.title = "Title is required.";
            }
            // A course saved without a weight has none stored (null), not an empty text
            const weight = String(formData.field_weight ?? '').trim();
            if (!weight) {
                newErrors.field_weight = "Weight(lbs) field is required.";
            }else if (!/^\d+$/.test(weight)) {
            newErrors.field_weight = "Only numbers are allowed in Weight (lbs).";
            }
            return newErrors;
        };
   const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        },
        field_weight:{
        border: errors.field_weight ? '2px solid red' : '1px solid #777'
        }
    };
 
const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validateForm();

  setErrors(validationErrors);
  setErrorMessage("");
  setViewChanges(false);
  setPreviewFields(false);
  setImageUploadError("");
  setImageUploadErrorLogo("");

  // If validation fails
  if (Object.keys(validationErrors).length > 0) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    return;
  }

  const finalBody = cleanHtmlOutput(formData.body);

  setDisabled(true);
  setButtonText("Saving...");

  const postData = new FormData();
  const updatedFormData = {
    ...formData,
    body: finalBody,
    
  };

  uploadedFiles.forEach(file => postData.append("files[]", file));

  if (selectedImage?.file) {
    postData.append("field_image", selectedImage.file);
  }

  if (selectedLogoImage?.file) {
    postData.append("field_course_logo", selectedLogoImage.file);
  }

  postData.append("formData", JSON.stringify(updatedFormData));

  try {
    const response = await fetch(app_url + "coursepages/updatepage", {
      method: "POST",
      body: postData,
    });

    const data = await response.json();

    if (data.data && data.data.msg === "Success") {
      // The saved page, at the address it has now (the URL alias may have changed)
      window.location.href= "/" + (data.data.url_slug || page.url_slug);
      // navigate("/" + page.url_slug, {
      //   state: { message: data.data.result },
      // });
    } else {
      
    setBackendErrorMessage((data.data && data.data.text) || data.message || "The page could not be saved.");
    }
  } finally {
    setDisabled(false);
    setButtonText("Save");
  }
};
   const handleDelete = async () => {
  if (window.confirm("Are you sure you want to delete?")) {
    const response = await fetch(
        app_url,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
       const data = await response.json();
      if(data.data.msg == "Success") {  
           //navigate("", { state: { message: data.data.result } });
           
        }
  }
};
    return(
         <>
            {isLoading ? (
                <Loading />
            ) : (
        <div id="main" className={` ${toggle === 2 ? "edit-blog-main" : "smww-agency-news-content-main"}`}>
        {!(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) ? (
            <p>You are not authorized</p>
        ) : !page ? (
            <p>The course page could not be loaded.</p>
        ) : <>
             {/* <Helmet>
                <title>
                    {getPageTitle()}
                </title>
            </Helmet> */}
            <div className="left"></div>
            <div className="center left-center">
                  <>
                    <h1 className="edit-task-title">{getPageHeading()}</h1>
                  </>
                <>
                  {( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                    <ul className="tabs primarya">
                      <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                        <a style={{cursor: "pointer"}}>View</a>
                      </li>
                    
                      <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                        <a style={{cursor: "pointer"}}>Edit</a>
                      </li>
                      {/* )} */}
                    </ul>
                  }
                </>
                       

{( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                       <div  className= {toggle === 2? "show-content" : "content"}>
                         {viewChanges && (
<div className='diff-table-wrapper'>
  <table className="diff-table">
  <colgroup>
    <col className="diff-marker" />
    <col className="diff-content" />
    <col className="diff-marker" />
    <col className="diff-content" />
  </colgroup>
  <thead>
    <tr>
      <th colSpan="2">Original</th>
      <th colSpan="2">Changes</th>
    </tr>
  </thead>
  <tbody>
    {!formDataSnapshot || !originalData ? (
      <tr className="no-changes">
        <td className="diff-section-title" colSpan="4">No visible changes</td>
      </tr>
    ) : (
      (() => {
        const diffs = [];

    
        const compareField = (label, oldValue = '', newValue = '') => {
  if (oldValue === newValue) return null;

  const oldLines = (oldValue ?? '').split('\n');
  const newLines = (newValue ?? '').split('\n');
  const maxLines = Math.max(oldLines.length, newLines.length);

  const rows = [
    <tr className="diff-section-title" key={`${label}-title`}>
      <td colSpan="4">Changes to <em>{label}</em></td>
    </tr>
  ];

  for (let i = 0; i < maxLines; i++) {
    const oldLine = (oldLines[i] || '').trim();
    const newLine = (newLines[i] || '').trim();

    if (oldLine !== newLine) {
      const oldWords = oldLine.split(/\s+/);
      const newWords = newLine.split(/\s+/);
      const maxWords = Math.max(oldWords.length, newWords.length);

      const renderWords = (wordsA, wordsB, isOld) =>
        wordsA.map((word, idx) => {
          const matchingWord = wordsB[idx] || '';
          const changed = word !== matchingWord;

          return (
            <span
              key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
              style={changed ? {
                color: isOld ? 'red' : 'red',
                borderRadius: '4px',
                padding: '0 3px',
                fontWeight:'bold'
              } : {}}
            >
              {word}
              {' '}
            </span>
          );
        });

      rows.push(
        <tr key={`${label}-${i}`}>
          <td style={{width:"2px"}}><span>-</span></td>
          <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
          <td style={{width:"2px"}}><span>+</span></td>
          <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
        </tr>
      );
    }
  }

  return rows;
};

// const compareFiles = (label, oldFiles = [], newFiles = []) => {
//   const oldList = oldFiles.map(f => f.name).join(', ');
//   const newList = newFiles.map(f => f.name).join(', ');

//   if (oldList !== newList) {
//     return [`${label} changed: ${oldList} → ${newList}`];
//   }

//   return [];
// };
const compareFiles = (label, oldFiles = [], newFiles = []) => {
  const oldList = Array.isArray(oldFiles)
    ? oldFiles.map(f => f.name).join(', ')
    : '';

  const newList = Array.isArray(newFiles)
    ? newFiles.map(f => f.name).join(', ')
    : '';

  // If no difference, return an empty array (safe + iterable)
  if (oldList === newList) {
    return [];
  }
  // Otherwise return whatever diff UI compareField creates
  return [compareField(label, oldList, newList)];
};


        diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));      
        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));
        // diffs.push(...(compareField('File Attachments', originalData.field_file_attachments, formDataSnapshot.field_file_attachments) || []));
//         diffs.push(...compareFiles(
//   'File Attachments',
//   originalData.field_file_attachments,
//   formDataSnapshot.field_file_attachments
// ));
        diffs.push(...(compareField('Meta Title', originalData.field_meta_title, formDataSnapshot.field_meta_title) || []));
        diffs.push(...(compareField('Meta Keywords', originalData.field_meta_keywords, formDataSnapshot.field_meta_keywords) || []));
        diffs.push(...(compareField('Meta Description', originalData.field_meta_description, formDataSnapshot.field_meta_description) || []));  
        diffs.push(...(compareField('Description for preview tile', originalData.field_apply_form_desc, formDataSnapshot.field_apply_form_desc) || []));
                diffs.push(
        ...(compareField(
            'Course Category',
            originalData.field_taxo_courses,
            formDataSnapshot.field_taxo_courses
        ) || [])
        );

        diffs.push(
        ...(compareField(
            'Application Key',
            originalData.field_application_key_name,
            formDataSnapshot.field_application_key_name
        ) || [])
        );

        diffs.push(
        ...(compareField(
            'Weight(lbs)',
            originalData.field_weight,
            formDataSnapshot.field_weight
        ) || [])
        );

        diffs.push(
        ...(compareField(
            'Next Start Month',
            originalData.field_next_start_month,
            formDataSnapshot.field_next_start_month
        ) || [])
        );

        diffs.push(
        ...(compareField(
            'Next Start Day',
            originalData.field_next_start_day,
            formDataSnapshot.field_next_start_day
        ) || [])
        );
              if (originalData.field_image !== formDataSnapshot.field_image) {
          diffs.push(
            <tr className="diff-section-title" key="preview-image-title">
              <td colSpan="4">Changes to <em>Image</em></td>
            </tr>,
            <tr key="preview-image-diff">
              <td><span>-</span></td>
              <td className="diff-removed">
                {originalData.field_image && getFileName(originalData.field_image)}
              </td>
              <td><span>+</span></td>
              <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                {formDataSnapshot.field_image && getFileName(formDataSnapshot.field_image)}
              </td>
            </tr>
          );
        }
        if (originalData.field_course_logo !== formDataSnapshot.field_course_logo) {
          diffs.push(
            <tr className="diff-section-title" key="banner-image-title">
              <td colSpan="4">Changes to <em>Course Logo</em></td>
            </tr>,
            <tr key="banner-image-diff">
              <td><span>-</span></td>
              <td className="diff-removed">
                {originalData.field_course_logo && getFileName(originalData.field_course_logo)}
              </td>
              <td><span>+</span></td>
              <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                {formDataSnapshot.field_course_logo && getFileName(formDataSnapshot.field_course_logo)}
              </td>
            </tr>
          );
        }
          diffs.push(
              ...(compareField(
              'URL Restriction',
              normalizeArray(getLabels(originalData.field_url_restriction)),
              normalizeArray(getLabels(formDataSnapshot.field_url_restriction))
            ) || [])
          );
            
  
          

        return diffs.length > 0 ? diffs : (
          <tr className="no-changes">
            <td className="diff-section-title" colSpan="4">No visible changes</td>
          </tr>
        );
      })()
    )}
  </tbody>
</table>
</div>
)}
{PreviewFields && (
  <>
    <div
      className="messages status"
      style={{
        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
        backgroundPosition: '10px 10px',
      }}
    >
      The trimmed version of your post shows what your post looks like when promoted
      to the main page or when exported for syndication.
      <span>
        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
        fine-tune where your post gets split.
      </span>
    </div>

    <div className="preview-container">
      {/* Trimmed version */}
      <div className="preview-trimmed">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview trimmed version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            <a href={"/content"}>{previewData?.title}</a>
          </h2>

          {/* <div className="email-teaser-block1">
            <div className="email-teaser-block2"> */}
              {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
  <div
    className="preview-body-content"
    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
  />
              )}
            {/* </div>
          </div> */}

          <div className="read-more-link">
            <a href={"/content"}>Read more</a>
          </div>
        </div>
      </div>

      {/* Full version */}
      <div className="preview-full">
        <h4 className="preview-heading">
          <span className="preview-square"></span> Preview full version
        </h4>

        <div className="email-teaser">
          <h2 className="email-title">
            {/* <strong>Body:</strong> */}
          </h2>

          {/* <div className="email-teaser-block1"> */}
            {/* <div className="email-teaser-block2"> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: previewData.body || '',
                }}
              />
              <div className="email-meta">
  
        {previewData.field_taxo_courses && (
        <p><strong>Course Category:</strong> {previewData.field_taxo_courses}</p>
    )}
    {previewData.field_application_key_name && (
        <p><strong>Application Key:</strong> {previewData.field_application_key_name}</p>
    )}
    {previewData.field_apply_form_desc && (
        <p><strong>Form Description:</strong> {previewData.field_apply_form_desc}</p>
    )}
    {previewData.field_weight && (
        <p><strong>Weight(lbs):</strong> {previewData.field_weight}</p>
    )}
   {previewData.field_meta_title && (
  <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
   {previewData.field_meta_keywords && (
  <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
   {previewData.field_meta_description && (
  <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}
    {/* Next Start Date Schedule */}
    {(previewData.field_next_start_month || previewData.field_next_start_day) && (
        <p>
            <strong>Next Start Date: </strong> 
            {previewData.field_next_start_month || 'None'} - {previewData.field_next_start_day || 'None'}
        </p>
    )}
   {previewData.field_image && (
        <div>
          <strong>Image:</strong><br />
          <img 
            src={getImageSrc(previewData.field_image)} 
            alt="Preview" 
            style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
          />
        </div>
      )}
       {previewData.field_course_logo && (
          <div>
            <strong>Course Logo:</strong><br />
            <img 
              src={getImageSrc(previewData.field_course_logo)} 
              alt="Preview" 
              style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
            />
          </div>
        )}

      {previewData.field_url_restriction && (
        <p>
          <strong>URL Restriction:</strong>{" "}
          {urlRestriction.filter(opt => previewData.field_url_restriction.includes(opt.value)).map(opt => opt.label).join(", ")}
        </p>
      )}

</div>

            {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  </>
)}
                <div className="edit-blog-container">
                             {Object.values(errors).some(msg => !!msg) && (
                                  <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                      background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                  >
                                    <ul>
                                      {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                          <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                                {backenderrorMessage && (
        <div 
            className="set-message-error" 
            style={{ 
                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                padding: "10px 10px 10px 50px",
                width: "90%",
            }}
        >
            {backenderrorMessage}
        </div>
    )}
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className="form-item">
                                <label htmlFor="create-agent-message-title">
                                    Title  
                                    <span className="form-required" title="This field is required.*">*</span>
                                </label>
                                <input 
                                    className="create-agent-message-title-field" 
                                    type="text" 
                                    id="create-agent-message-title" 
                                    name="title" 
                                    maxLength={100}
                                    onChange={handleChange} 
                                     value={formData.title}
                                    style={inputStyle.title}
                            
                                />
                                    {/* {errors.title && (
                                    <div className="form-error">{errors.title}</div>
                                )} */}
                            </div>
                               <div className="form-item">
                                    <label htmlFor="edit-field-taxo-courses">Courses </label>
                                 <select
                                  id="edit-field-taxo-courses"
                                  name="field_taxo_courses"
                                  className="form-select"
                                  value={formData.field_taxo_courses || "_none"}
                                  onChange={handleChange}
                              >
                                  <option value="_none">- None -</option>

                                  {courses.map((item, index) => (
                                      <option
                                          key={index}
                                          value={item.course_name}
                                      >
                                          {item.course_name}
                                      </option>
                                  ))}
                              </select>
                                    </div>
                                        <div className="form-item  fieldmeta-description">
          <label>Description for preview tile</label>
          <textarea
            name="field_apply_form_desc"
            value={formData.field_apply_form_desc}
            onChange={handleChange}
            
          />
                                <div className="grippie" style={{
    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
  }}>   
  </div>

        </div>
          <div className="form-item">
                                    {/* In React, 'for' becomes 'htmlFor' */}
                                    <label htmlFor="edit-field-application-key-name">
                                        Application Key Name
                                    </label>
                                    
                                    <input 
                                        className="text-full form-text" 
                                        type="text" 
                                        id="edit-field-application-key-name" 
                                        name="field_application_key_name" 
                                        size={60} 
                                        maxLength={255}
                                        value={formData.field_application_key_name}
                                        onChange={handleChange}
                                    />
                                    </div>
                                    <div className="form-item">
                                    <label htmlFor="edit-field-weight-und-0-value">
                                        Weight (lbs) <span className="form-required" title="This field is required.">*</span>
                                    </label>
                                    
                                    <input 
                                        type="text" 
                                        id="edit-field-weight" 
                                        name="field_weight" 
                                        size={12} 
                                        maxLength={10} 
                                        value={formData.field_weight}
                                        onChange={handleChange}
                                        style={inputStyle.field_weight}
                                    />

                                    
                                    </div>
                            <div className="">
                                <div>
                                    {showSummary && (
                                        <div className="form-item">
                                            <label htmlFor="create_summary">
                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                            </label>
                                            <>
                                                <>
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.summary} 
                                                        // onChange={e => onEditorChange('summary', e.target.value)} 
                                                        onChange={value => onEditorChange('summary', value)}
                                                    />
                                                </>
                                            </>
                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                        </div>
                                    )}
                            
                                    <div className="form-item">
                                        <label htmlFor="create_body">
                                            Body 
                                            {!showSummary && (
                                                <span>
                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                        Edit Summary
                                                    </a>)
                                                </span>
                                            )}
                                        </label>
                                        <>
                                            {useRichEditor ? (
                                                <> 
                                                    <Editor 
                                                        containerProps={{ style: { resize: 'vertical' } }} 
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)}
                                                        // onChange={value => onEditorChange('body', value)}
                                                         onChange={handleEditorChange}

                                                    />  
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                        Switch to plain text editor
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <textarea
                                                        id="create_body"
                                                        rows="20"
                                                        value={formData.body} 
                                                        // onChange={e => onEditorChange('body', e.target.value)} 
                                                        onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) }
                                                    />
                                                    <div 
                                                        className="grippie" 
                                                        style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                    >
                                                    </div>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                        Switch to rich text editor
                                                    </a>
                                                </>
                                            )}
                                        </>
                                    </div>
                                   
                                     </div>
                                     </div>
                 <div className="form-item -field-meta-title">
          <label htmlFor="meta_title">Meta Title</label>
          <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
           onChange={handleChange}  
        /> 
      </div>
      <div className="form-item field-meta-keywords">
          <label htmlFor="meta_keywords">Meta Keywords</label>
          <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
             onChange={handleChange}
          /> 
      </div>
              <div className="form-item  fieldmeta-description">
          <label>Meta Description</label>
          <textarea
            name="field_meta_description"
            value={formData.field_meta_description}
            onChange={handleChange}
            
          />
                                <div className="grippie" style={{
    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
  }}>   
  </div>

        </div>
          <p>File Attachments</p>
                                    <div className="fieldset-wrapper">
    {(uploadedFiles?.length > 0 || backenduploadedFiles?.length > 0) && (
        <table className="" style={{fontSize:"14px", width:"90%"}}>
            <thead>
                <tr style={{textAlign:"left"}}>
                <th>File information</th>
                <th>Operations</th>
                </tr>
            </thead>
            <tbody style={{backgroundColor: "#eee", borderBottom: "1px solid #ccc"}}>
                {uploadedFiles?.length > 0 && uploadedFiles.map((file, index) => (
                <tr key={index}>
                    <td>
                    <span className="file">
                        <img
                            className="file-icon"
                            alt="File icon"
                            src={getFileIcon(file.name)}
                            style={{ marginRight: '8px' }}
                        />
                        <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                        {file.name}
                        </a>
                    </span>
                    <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                    </td>
                    <td>
                    <button
                        type="button"
                        className="form-submit"
                        onClick={() => removeFile(index)}
                    >
                        Remove
                    </button>
                    </td>
                </tr>
                ))}
                 {backenduploadedFiles?.length > 0 && backenduploadedFiles.map((file, index) => (
                <tr key={index}>
                    <td>
                    <span className="file">
                        <img
                            className="file-icon"
                            alt="File icon"
                            src={getFileIcon(file.name)}
                            style={{ marginRight: '8px' }}
                        />
                        <a href={file.url} target="_blank" rel="noreferrer">
                        {file.name}
                        </a>
                    </span>
                    <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                    </td>
                    <td>
                    <button
                        type="button"
                        className="form-submit"
                        onClick={() => removeBackendFile(index,file.fid)}
                    >
                        Remove
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
        </table>
    )}
    
    {errorMessage && (
        <div 
            className="set-message-error" 
            style={{ 
                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                padding: "10px 10px 10px 50px",
                width: "90%",
            }}
        >
            {errorMessage}
        </div>
    )}

    <div className="form-item">
        <label htmlFor="edit-field-agent-contract">Add a new file</label>
        <div>
            <input
                type="file"
                id="edit-field-agent-contract"
                name="field_file_attachments"
                className="form-file"
                multiple
                onChange={handleFileInputChange}
                key={fileInputKey}
                style={{width: "auto"}}
            />
            <button type="button" onClick={handleUpload} disabled={selectedFiles.length === 0} className="form-submit">
                Upload
            </button>
        </div>
        <div className="description" style={{fontSize:".85em"}}>
            Files must be less than <b>2 MB</b>.<br />
            Allowed file types: <b>jpg jpeg gif png txt doc xls pdf ppt pps odt ods odp</b>.
        </div>
    </div>

</div>
       
                                     <div class="form-item">
                                <label for="edit-field-header-image">Header Image </label>
                                <input class="text-full form-text" type="text" id="edit-field-header-image-und-0-value" name="field_header_image" value={formData.field_header_image} onChange={handleChange} size="60" maxlength="100"/>
                                </div>
                                   <div>
                        {imageUploadError && (
                          <div 
                            className="set-message-error error-message-padding"
                            style={{
                              background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                            >
                              <div 
                              style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px',
                                marginLeft:'30px'                                 
                              }}
                            dangerouslySetInnerHTML={{ __html: imageUploadError }}
                          >                            
                          </div>
                          </div>
                        )}
                        <div>
                          <label>Image </label>
                          {selectedImage ? (
                            // Case 1: New image selected
                            <>
                              <div className="edit-agent-image-container">
                                <img alt="Uploaded" src={selectedImage.preview} style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}} />
                                <div className="image-info">
                                  <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(imageFileName)}
                                />
                                  <a
                                    href={selectedImage.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {imageFileName}
                                  </a>
                                  <span className="image-size">
                                    ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSelectedImage('image')}
                              />
                            </>
                          ) : formData.field_image ? (
                            // Case 2: Image already saved (URL string from backend)
                            <>
                              <div className="edit-scout-report-image-container">
                                <img
                                  alt="Uploaded"
                                  src={formData.field_image?.url}
                                  style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}}
                                />
                                <div className="image-info">
                                <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(formData.field_image?.name)}
                                  width="16"
                                  height="16"
                                />
                                  <a
                                    href={formData.field_image?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {imageFileName}
                                  </a>
                                  <span className="image-size">
                                      {uploadedImage
                                        ? `(${(uploadedImage.size / 1024).toFixed(2)} KB)`
                                        : ""}
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSavedImage('image')}
                              />
                            </>
                          ) : (
                            // Case 3: No image yet → show upload input
                            <div>
                              <input
                                type="file"
                                id="edit-agent-photo-upload"
                                name="edit_agent_photo_upload"
                                accept="image/*"
                                onChange={(e) => handleTempImageChange(e, 'image')}
                              />
                              <input
                                type="button"
                                value="Upload"
                                className="form-submit"
                                onClick={() => handleImageUploadClick('image')}
                              />
                            </div>
                          )}

                          {!formData.field_image && !selectedImage && (
                            <div className="description" style={{fontSize:"12px"}}>
                              Files must be less than <b>128 MB</b>.<br />
                              Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                          )}
                        </div>
                      </div>    
                      <div style={{clear:"both"}}></div> 
                                  <div className="form-item">
                                <label htmlFor="edit-field-call-back-day">Day </label>
                                <div className="call-back-field">
                                <select 
                                    className="" 
                                    id="edit-field-call-back-day" 
                                    name="field_next_start_day"
                                    value={formData.field_next_start_day}
                                    onChange={handleChange}
                                >
                                    <option value="">-None-</option>
                                    {days.map((d) => (
                                    <option key={d.value} value={d.value}>
                                        {d.label}
                                    </option>
                                    ))}  
                                </select>
                                </div>
                            </div>
                              <div className="form-item">
                            <label htmlFor="edit-field-call-back-month">Month </label>
                            <div className="call-back-field">
                            <select 
                                className="" 
                                id="edit-field-call-back-month" 
                                name="field_next_start_month"
                                value={formData.field_next_start_month}
                                onChange={handleChange}
                            >
                                <option value="">-None-</option>
                                {months.map((m) => (
                                    <option key={m.value} value={m.value}>
                                    {m.label}
                                    </option>
                                ))}
                            </select>
                            </div>
                        </div>
                           <div className="">
                            <label>URL Restriction</label>
                            <div>
                                {urlRestriction.map((url) => (
                                <label key={url.value} style={{ fontWeight: 'normal', lineHeight: '2' }}>
                                    <input
                                    type="checkbox"
                                    name="field_url_restriction"
                                    value={url.value}
                                    // checked={formData.field_url_restriction?.includes(url.value)}
                                    checked={
                                      Array.isArray(formData.field_url_restriction) &&
                                      formData.field_url_restriction.includes(url.value)
                                    }
                                    onChange={handleChange}
                                    />
                                    {url.label}
                                </label>
                                ))}
                            </div>
                          </div>
                            <div>
                        {imageUploadErrorLogo && (
                          <div 
                            className="set-message-error error-message-padding"
                            style={{
                              background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                            >
                              <div 
                              style={{ color: '#8c2e0b',                                
                                backgroundColor: '#fef5f1',                                 
                                marginBottom: '10px', 
                                width: '80%',
                                borderRadius: '5px',
                                marginLeft:'30px'                                 
                              }}
                            dangerouslySetInnerHTML={{ __html: imageUploadErrorLogo }}
                          >                            
                          </div>
                          </div>
                        )}
                        <div>
                          <label>Course Logo</label>
                          {selectedLogoImage ? (
                            // Case 1: New image selected
                            <>
                              <div className="edit-agent-image-container">
                                <img alt="Uploaded" src={selectedLogoImage.preview} style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}} />
                                <div className="image-info">
                                  <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(logoFileName)}
                                />
                                  <a
                                    href={selectedLogoImage.preview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {logoFileName}
                                  </a>
                                  <span className="image-size">
                                    ({(selectedLogoImage.file.size / 1024).toFixed(2)} KB)
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSelectedImage('logo')}
                              />
                            </>
                          ) : formData.field_course_logo? (
                            // Case 2: Image already saved (URL string from backend)
                            <>
                              <div className="edit-scout-report-image-container">
                                <img
                                  alt="Uploaded"
                                  src={formData.field_course_logo?.url}
                                  style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}}
                                />
                                <div className="image-info">
                                <img
                                  className="file-icon"
                                  alt="File icon"
                                  src={getFileIcon(formData.field_course_logo?.name)}
                                  width="16"
                                  height="16"
                                />
                                  <a
                                    href={formData.field_course_logo?.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="image-name-link"
                                  >
                                    {logoFileName}
                                  </a>
                                  <span className="image-size">
                                      {uploadedLogoImage
                                        ? `(${(uploadedLogoImage.size / 1024).toFixed(2)} KB)`
                                        : ""}
                                  </span>
                                </div>
                              </div>
                              <input
                                type="button"
                                value="Remove"
                                className="form-submit"
                                onClick={() => handleRemoveSavedImage('logo')}
                              />
                            </>
                          ) : (
                            // Case 3: No image yet → show upload input
                            <div>
                              <input
                                type="file"
                                id="edit-agent-photo-upload"
                                name="edit_agent_photo_upload"
                                accept="image/*"
                                onChange={(e) => handleTempImageChange(e, 'logo')}
                              />
                              <input
                                type="button"
                                value="Upload"
                                className="form-submit"
                                // onClick={() =>
                                //   document.getElementById("edit-agent-photo-upload").click()
                                // }
                                onClick={() => handleImageUploadClick('logo')}
                              />
                            </div>
                          )}

                          {!formData.field_image && !selectedLogoImage && (
                            <div className="description" style={{fontSize:"12px"}}>
                              Files must be less than <b>128 MB</b>.<br />
                              Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{clear:"both"}}></div>
                        <fieldset 
    className="form-wrapper" 
    style={{
        border: "1px solid #ccc", 
        padding: "15px 20px", 
        marginBottom: "15px",
        fontFamily: "sans-serif"
    }}
>
    {/* Fieldset Legend Header */}
    <legend style={{ padding: "0 5px", fontWeight: "bold", fontSize: "12px", color: "#333" }}>
        
    </legend>

    <div className="editprofile-fieldset-wrapper">
        <label>PLACEMENTS</label>
        <table 
            style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "white",
                border: "1px solid #ccc",
                fontSize: "11px"
            }} 
            className="placements-table"
        >
            <thead>
                <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                    <th style={{ 
                        width: '70%', 
                        padding: '6px 10px', 
                        textAlign: 'left', 
                        fontWeight: 'bold', 
                        color: '#333',
                        textTransform: 'uppercase',
                        borderRight: '1px solid #ccc'
                    }}>
                        Page
                    </th>
                    <th style={{ 
                        width: '15%', 
                        padding: '6px 10px', 
                        textAlign: 'left', 
                        fontWeight: 'bold', 
                        color: '#333',
                        textTransform: 'uppercase',
                        borderRight: '1px solid #ccc'
                    }}>
                        Sort Order
                    </th>
                    <th style={{ 
                        width: '15%', 
                        padding: '6px 10px', 
                        textAlign: 'center', 
                        fontWeight: 'bold', 
                        color: '#333',
                        textTransform: 'uppercase'
                    }}>
                        Delete
                    </th>
                </tr>
            </thead>
            <tbody>
                {formData.placements.map((placement, index) => (
                    <tr key={index} style={{ borderBottom: index < formData.placements.length - 1 ? "1px solid #ccc" : "none" }}>
                        {/* Page Select Column */}
                        <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                            <select
                                className="placement-select"
                                name={`placement_page_${index}`}
                                value={placement.placement_page}
                                onChange={(e) =>
                                    handlePlacementChange(index, 'placement_page', e.target.value)
                                }
                                style={{
                                    width: "100%",
                                    padding: "4px",
                                    border: "1px solid #ccc",
                                    borderRadius: "2px",
                                    fontSize: "12px",
                                    boxSizing: "border-box"
                                }}
                            >
                                <option value="">Select a page</option>
                                {pages.length > 0 && (
                                    <>
                                        {pages.map((item) => (
                                            <option key={item['id']} value={item['id']}>
                                                {item['title']}
                                            </option>
                                        ))}
                                    </>
                                )}
                            </select>
                        </td>

                        {/* Sort Order Select Column */}
                        <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                            <select
                                name={`placement_sort_order_${index}`}
                                className="adduser-form-select"
                                value={placement.placement_sort_order}
                                onChange={(e) =>
                                    handlePlacementChange(index, 'placement_sort_order', e.target.value)
                                }
                                style={{
                                    width: "100%",
                                    maxWidth: "60px",
                                    padding: "4px",
                                    border: "1px solid #ccc",
                                    borderRadius: "2px",
                                    fontSize: "12px"
                                }}
                            >
                                {[...Array(50)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                    </option>
                                ))}
                            </select>
                        </td>

                        {/* Delete Button Column */}
                        <td style={{ padding: '10px', textAlign: 'center' }}>
                            <button
                                type="button"
                                className='quick-links-reg-button form-submit'
                                onClick={() => handleDeletePlacement(index)}
                                
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        {/* Add Placement Link */}
        <div style={{ marginTop: "12px" }}>
            <a
                className="add-placement-link"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    handleAddPlacement();
                }}
                style={{
                    color: "#0071B8",
                    textDecoration: "none",
                    fontWeight: "bold",
                    fontSize: "12px"
                }}
                onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
            >
                + Add
            </a>
        </div>
    </div>
</fieldset>
        
                         
                            <div className="form-item">
                                <label htmlFor="edit-path-alias">
                                    URL alias
                                </label>
                                <input
                                    type="text" 
                                    id="edit-path-alias" 
                                    name="url_alias" 
                                    // maxLength={100}
                                    onChange={handleChange} 
                                    value={formData.url_alias}
                            
                                />
                            <p className="description" style={{marginTop: "5px"}}>Optionally specify an alternative URL by which this content can be accessed. For example, type "about" when writing an about page. 
                              Use a relative path and don't add a trailing slash or the URL alias won't work.</p>
                            </div>       
                      
                            <div className="form-actions form-wrapper" id="create-actions">
                                {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                                <button type="submit" className="form-submit" disabled={disabled}>{buttontext}</button>&nbsp;&nbsp;
                               <input 
                                          type="button" 
                                          id="edit-preview"  
                                          value="Preview" 
                                          className="form-submit" 
                                          onClick={()=> {
                                          handlePreviewClick();
                                          // window.scrollTo({ top: 0, behavior: 'smooth' });
                                          }}
                                        />&nbsp;&nbsp;
                                        <input
                                          type="button"
                                          id="edit-task-preview-changes"
                                          value="View changes"
                                          className="form-submit"
                                          onClick={handleViewChangesClick}
                                        />&nbsp;&nbsp;

                                        <input type="button" id="edit-task-delete" name="" value="Delete" className="form-submit" onClick={handleDelete} />
                            </div>
                        </div>
                    </form>
                </div>
                </div>
}
            </div>
        </>}
        </div>
            )}
            </>
    );
};
export default EditNewCourse;